import { flagFactory } from '../icon';
import Svg from './dk.svg';

export default flagFactory(Svg);
